import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const PriceDetailsPanel = ({ price, onClose, onEdit }) => {
  if (!price) return null;

  const priceData = price;

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  const fiat = priceData.fiat || priceData.Fiat || priceData.FIAT || '-';
  const gwPayIn = priceData.gwPayIn || priceData.GwPayIn || priceData.GWPAYIN || '-';
  const gwPayOut = priceData.gwPayOut || priceData.GwPayOut || priceData.GWPAYOUT || '-';
  const payIn = priceData.payIn || priceData.PayIn || priceData.PAY_IN || '-';
  const payOut = priceData.payOut || priceData.PayOut || priceData.PAY_OUT || '-';
  const created = formatDate(priceData.Created || priceData.created || price.create_time || priceData.create_time);
  const changed = formatDate(priceData.LastChanged || priceData.lastChanged || price.change_time || priceData.change_time);

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Price Details</h2>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {onEdit && (
              <button
                className="edit-button"
                onClick={() => onEdit(price)}
              >
                Edit
              </button>
            )}
            <button type="button" className="close-button" onClick={onClose}>Close</button>
          </div>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Fiat</span>
              <span className="summary-primary">{formatValue(fiat)}</span>
              <span className="summary-secondary">Rate configuration</span>
            </div>
            <div className="summary-chips">
              <span className="summary-chip">GwPayIn: {formatValue(gwPayIn)}</span>
              <span className="summary-chip">GwPayOut: {formatValue(gwPayOut)}</span>
              <span className="summary-chip">PayIn: {formatValue(payIn)}</span>
              <span className="summary-chip">PayOut: {formatValue(payOut)}</span>
            </div>
          </div>

          <div className="detail-section">
            <h3>Rates</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Fiat</span>
                <span className="detail-value">{formatValue(fiat)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">GwPayIn</span>
                <span className="detail-value">{formatValue(gwPayIn)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">GwPayOut</span>
                <span className="detail-value">{formatValue(gwPayOut)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">PayIn</span>
                <span className="detail-value">{formatValue(payIn)}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">PayOut</span>
                <span className="detail-value">{formatValue(payOut)}</span>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h3>Timeline</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Last Changed</span>
                <span className="detail-value">{changed}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default PriceDetailsPanel;
